import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBPatchLast13m',
        endpoint:           endpoints.cmdb.patchLast13m,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => [
            {
                name: 'withPatch',
                data: response.with_patch.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY}))
            },
            {
                name: 'withoutPatch',
                data: response.without_patch.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY}))
            }
        ]
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBPatchLast13m.js